import { orchestrator } from 'satcheljs';
import { fetchArchiveDumpsterFolder } from '../actions/internalActions';
import { onFindDumpsterFolderSuccess } from '../actions/publicActions';
import { ARCHIVE_DUMPSTER_DISTINGUISHED_ID } from 'owa-folders-constants';
import { getMailboxInfoForFolderId } from '../util/getMailboxInfoForFolderId';
import { lazyFolderHierarchyDocument } from 'owa-folders-hierarchy-graphql-documents';
import { getApolloClient } from 'owa-apollo';

/**
 * An orchestrator that gets the dumpster folder for archive mailbox folder tree and add mapping to session store.
 */
export default orchestrator(fetchArchiveDumpsterFolder, async () => {
    const mailboxInfo = getMailboxInfoForFolderId(
        ARCHIVE_DUMPSTER_DISTINGUISHED_ID,
        false /*routeToAuxIfAuxArchive*/
    );
    const query = await lazyFolderHierarchyDocument.import();

    let findFolderResponse;
    try {
        const folderHierarchyResponse = await getApolloClient().query({
            query,
            variables: {
                baseFolderDistinguishedIds: [ARCHIVE_DUMPSTER_DISTINGUISHED_ID],
                mailboxInfo: {
                    userIdentity: mailboxInfo.userIdentity,
                    mailboxSmtpAddress: mailboxInfo.mailboxSmtpAddress,
                    type: mailboxInfo.type,
                },
            },
        });
        findFolderResponse = folderHierarchyResponse.data.folderHierarchy;
    } catch (e) {
        return;
    }

    onFindDumpsterFolderSuccess(findFolderResponse.RootFolder, findFolderResponse.Folders);
});
